"use client"; // Error components must be Client Components

import type { ReactNode } from "react";

import { Container } from "@radix-ui/themes";
import clsx from "clsx";

import { robotoCondensed } from "@/fonts";
import { LegacyUrl, legacyUrls } from "@/src/app/legacyUrls";
import { ButtonLink } from "@/src/components/ui/Button/ButtonLink";
import { HeadingBanner } from "@/src/components/ui/HeadingBanner";

export default function Error({
  error,
}: {
  readonly error: { digest?: string } & Error;
}): ReactNode {
  return (
    <main>
      <HeadingBanner
        title={
          <span className="before:mr-2 before:content-['⚙️']">
            Problème technique
          </span>
        }
      />
      <Container className="page-content-py px-4" size="4">
        <p
          className={clsx(
            robotoCondensed.className,
            "font-medium-antialiased mb-4 text-center text-lg",
          )}
        >
          Merci pour votre patience, nous revenons bientôt…
        </p>
        {error.digest ? (
          <p className="mb-6 flex items-center justify-center gap-2">
            Envoyez-nous ce code d’erreur :
            <span className="bg-gray-lightest rounded-sm px-2 py-1 font-mono text-sm">
              {error.digest}
            </span>
          </p>
        ) : null}
        <ButtonLink
          className={clsx(
            "m-auto block w-full",
            "after:ml-2 after:content-['😊']",
            "sm:w-auto",
          )}
          href={legacyUrls[LegacyUrl.home]}
          size="big"
        >
          Retourner à l’accueil
        </ButtonLink>
      </Container>
    </main>
  );
}
